import { createAsyncThunk } from '@reduxjs/toolkit';

import type { EventCancelResponse } from '../../api/types';
import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const cancelEvent = createAsyncThunk<
  EventCancelResponse,
  { eventId: string },
  { state: RootState }
>('events/cancel', async ({ eventId }, thunkApi) => {
  const { dispatch, getState } = thunkApi;

  try {
    const res = await eventsService.cancelEvent({ eventId });
    // Backend currently deletes the event on this endpoint (DELETE /event/{id}).
    // Keep UI consistent by removing it from local cache.
    dispatch(entitiesActions.removeEvent(eventId));
    return res;
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Не удалось отменить мероприятие';
    throw error;
  }
});
